import React, { useState } from "react";
import "./FDCertificate.css";

const FDCertificate = () => {
  const [formData, setFormData] = useState({
    company: "",
    CIN: "",
    branch: "",
    depositor: "",
    nominee: "",
    number: "",
    certificateNo: "",
    pan: "", 
    name: "",
    id: "",
    DepositeType:"",
    totalInterest:"",
    Repayble:"",
    Nominee:"",
    Address:"",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="FDcertificate-container">
      {/* Background watermark */}
      
      <div className="FDcertificate-watermark">
  {Array.from({ length: 200 }).map((_, i) => (
    <span key={i}>Techvision Company</span>
  ))}
</div>

        <div className="FDcertificate-center"></div>
      {/* Header */}
      <div className="FDcertificate-header">
        <h1>TECHVISION LIMITED</h1>
        <p>CIN : U1243253465475PL603434</p>
      </div>
      <div className="FDcertificate-header1">
        <h1>Fixed Deposit Certificate</h1>
      </div>

      {/* Details form in grid layout */}
      <div className="FDdetails">
        <div className="FDrow">
          <label>PAN Number :</label>
          <input
            type="text"
            name="pan"
            value={formData.pan}
            onChange={handleChange}
            placeholder="ABCDE1234F"
          />

          <label>Branch :</label>
          <input
            type="text"
            name="branch"
            value={formData.branch}
            onChange={handleChange}
            placeholder="Enter Branch"
          />
        </div>

        <div className="FDrow">
          <label>Mr./Mrs. :</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter Name"
          />

          <label>Customer ID :</label>
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            placeholder="Enter ID"
          />
        </div>

        <div className="FDrow">
          <label>Account Number :</label>
          <input
            type="text"
            name="number"
            value={formData.number}
            onChange={handleChange}
            placeholder="Enter Account Number"
          />

          <label>Deposite Type :</label>
          <input
            type="text"
            name="DepositeType"
            value={formData.DepositeType}
            onChange={handleChange}
            placeholder=""
          /></div>
    
        
             <div className="FDrow-single">
              <label>Total Interest :</label>
              <input
               type="text"
               name="totalInterest"
               value={formData.totalInterest}
               onChange={handleChange}
               placeholder=""
                 />

                 <label>Customer Address :</label><input
               type="text"
               name="Address"
               value={formData.Address}
               onChange={handleChange}
               placeholder=""
                 />
                </div>
     
         <div className="FDrow">
          <label>Repayble to :</label>
          <input
            type="text"
            name="Repayble"
            value={formData.Repayble}
            onChange={handleChange}
            placeholder="Not Applicable"
          />

          <label>Nominee Name :</label>
          <input
            type="text"
            name="Nominee"
            value={formData.Nominee}
            onChange={handleChange}
            placeholder=""
          /></div>
             

             <table className="FDtable">
  <thead>
    <tr>
      <th>SR.</th>
      <th>Deposit Date</th>
      <th>Deposit Period</th>
      <th>Rate(%)</th>
      <th>Deposit Amount</th>
      <th>Maturity Date</th>
      <th>Maturity Amount</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>
        <input
          type="date"
          name="depositDate"
          value={formData.depositDate}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="depositPeriod"
          value={formData.depositPeriod}
          onChange={handleChange}
          placeholder="e.g. 5 Years"
        />
      </td>
      <td>
        <input
          type="number"
          name="rate"
          value={formData.rate}
          onChange={handleChange}
          placeholder="%"
        />
      </td>
      <td>
        <input
          type="number"
          name="depositAmount"
          value={formData.depositAmount}
          onChange={handleChange}
          placeholder="₹"
        />
      </td>
      <td>
        {/* Removed the date picker and changed to text input */}
        <input
          type="text"
          name="maturityDate"
          value={formData.maturityDate}
          onChange={handleChange}
          placeholder="dd-mm-yyyy"
        />
      </td>
      <td>
        <input
          type="number"
          name="maturityAmount"
          value={formData.maturityAmount}
          onChange={handleChange}
          placeholder="₹"
        />
      </td>
    </tr>
  </tbody>
</table>
    <p className="FDpara">(Rupees Fifty Thousand Only)</p>
        

      </div>

        
<div className="FD-certificate-box">
  <p>
    <strong>In the Name of :</strong>
    <p><span>Techvision </span> </p>
  </p>

  <p className="FD-company-name">For Techvision Company</p>

  <div className="FD-signature">
    <p>_______________________</p>
    <p>Authorised Signatories</p>
  </div>

  <p className="FD-thank-you">
    THANK YOU FOR YOUR CONTINUED PATRONAGE WITH OUR COMPANY
  </p>

  <p className="FD-address">
    <strong>Head Office :</strong> hwefdhwecjhewbcfe
  </p>
</div>




    </div>
  );
};

export default FDCertificate;
